var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 83 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Tiktok",
    transform: "matrix(1,0,0,0.920904,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 83.705,
    height: 88.5,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.08589,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.852,0.5C64.067,0.5 82.102,18.535 82.102,40.75C82.102,62.965 64.067,81 41.852,81C19.638,81 1.602,62.965 1.602,40.75C1.602,18.535 19.638,0.5 41.852,0.5ZM41.602,18.5L41.602,50C41.602,52.479 39.586,54.5 37.102,54.5C34.618,54.5 32.602,52.479 32.602,50C32.602,47.52 34.618,45.5 37.102,45.5L37.102,36.5C29.659,36.5 23.602,42.557 23.602,50C23.602,57.443 29.659,63.5 37.102,63.5C44.545,63.5 50.602,57.443 50.602,50L50.602,33.283C53.608,35.304 56.88,36.5 59.602,36.5L59.602,27.5C57.222,27.5 50.602,23.022 50.602,18.5L41.602,18.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e565b389cbb391c98e17db9330454614.svg";
export { ForwardRef as ReactComponent };